import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  GenericConfirmDialogComponent,
  MzicPopoverStyleEnum,
} from '@mzic/mzic-components';
import { Subscription } from 'rxjs';
import { GenericConfirmDialogData } from '../../../../mzic-components/src/lib/components/generic-confirm-dialog/types';

@Component({
  selector: 'mzic-dialogs',
  imports: [CommonModule],
  templateUrl: './dialogs.component.html',
  styleUrl: './dialogs.component.scss',
})
export class DialogsComponent implements OnDestroy {
  dialog = inject(MatDialog);
  dialogRef$: Subscription | undefined;

  ngOnDestroy(): void {
    this.dialogRef$?.unsubscribe();
  }

  openDialog1() {
    this.openDialog({
      title: 'Tem certeza que deseja isso?',
      description: 'Aqui vai algum texto que você pode querer explicar.',
      confirmButton: 'CONFIRM',
      cancelButton: 'CANCEL',
    });
  }

  openDialog2() {
    this.openDialog({
      title: 'Tem certeza que deseja isso?',
      description: 'Aqui vai algum texto que você pode querer explicar.',
      confirmButton: 'TENHO CERTEZA',
      cancelButton: 'CANCELAR',
    });
  }

  openDialog3() {
    this.openDialog({
      title: 'Tem certeza que deseja isso?',
      description: 'Aqui vai algum texto que você pode querer explicar.',
      confirmButton: 'CONFIRM',
      cancelButton: 'CANCEL',
      theme: 'centralized',
      iconUrl: 'assets/icons/mzic-close-filled.svg',
      iconClass: 'red-500',
      iconSize: 'w64',
    });
  }

  openDialog(genericData: GenericConfirmDialogData) {
    /**
     * Cria a dialog, para passar dados para ela, usamos o data, onde podemos customizar titulo, icone, etc.
     */
    const dialogRef = this.dialog.open(GenericConfirmDialogComponent, {
      panelClass: MzicPopoverStyleEnum.DIALOG,
      width: '350px',
      disableClose: true,
      autoFocus: false,
      data: genericData,
    });

    // Esse evento fica observando alterações no dialog, quando ele fechar, ele vai emitir o evento
    this.dialogRef$ = dialogRef.componentInstance.actionChange.subscribe(
      (event: 'CONFIRM' | 'CANCEL') => {
        if (event === 'CONFIRM') {
          alert('Confirmed');
        }

        if (event === 'CANCEL') {
          alert('Canceled');
        }

        dialogRef.close();
      },
    );
  }
}
